import { type ReactElement } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { HOME_HEALTH_CASES_PATH } from "../ExperimentalHomeHealth/Cases/paths";
import { HOME_HEALTH_VISIT_VERIFICATION_PATH } from "../ExperimentalHomeHealth/VisitVerification/paths";
import { HelpCenterPage as LegacyHelpCenterPage } from "../HelpCenter/Page";
import { HELP_CENTER_PATH } from "../HelpCenter/paths";
import { NotFoundPage } from "../lib";
import { HelpCenterPage as RedesignedHelpCenterPage } from "../redesign/HelpCenter/Page";
import { useIsRedesignEnabled } from "../redesign/hooks/useIsRedesignEnabled";

function HelpCenterRoute() {
  const isRedesignEnabled = useIsRedesignEnabled();

  if (isRedesignEnabled) {
    return <RedesignedHelpCenterPage />;
  }

  return <LegacyHelpCenterPage />;
}

export function AppV2PrivateRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${HELP_CENTER_PATH}`}>
        <HelpCenterRoute />
      </Route>
      <Route exact path={match.url}>
        <div>This is a private route from appV2</div>
      </Route>
      <Redirect from={`${match.url}/home-health/cases`} to={HOME_HEALTH_CASES_PATH} />
      <Redirect
        from={`${match.url}/home-health/visit-verification`}
        to={HOME_HEALTH_VISIT_VERIFICATION_PATH}
      />
      <Route path="*">
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
